import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav } from 'react-bootstrap';

const DocumentationSidebar = () => {
    return (
        <Nav className="flex-column">
            <NavLink to="/documentation/about" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                About the Application
            </NavLink>
            <NavLink to="/documentation/technical" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                API Documentation
            </NavLink>
            <NavLink to="/documentation/license" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Library and License Information
            </NavLink>
            <NavLink to="/documentation/code-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Code Documentation
            </NavLink>
            <NavLink to="/documentation/decision-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Decision Documentation
            </NavLink>
            <NavLink to="/documentation/tool-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Decision Documentation Updated
            </NavLink>
            <NavLink to="/documentation/agent-prompt-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Results & Prompt Documentation
            </NavLink>
            <NavLink to="/documentation/how-to-run" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                How to Run the Code
            </NavLink>
            <NavLink to="/documentation/investor-notes" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Notes for Investors and Customer Queries
            </NavLink>
            <NavLink to="/documentation/costing" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Project Costing
            </NavLink>
            <NavLink to="/documentation/dependency-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Dependency Documentation
            </NavLink>
            <NavLink to="/documentation/auth-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Authentication Documentation
            </NavLink>
            <NavLink to="/documentation/security-documentation" className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}>
                Security Documentation
            </NavLink>
        </Nav>
    );
};

export default DocumentationSidebar;
